import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'aerovaleNumero'
})
export class AerovaleNumeroPipe implements PipeTransform {

  transform(value: number): string {
    if (value !== undefined && value !== null) {
      return value.toString().padStart(5, '0');
    } else {
      return "";
    }
  }

}
